const loadMoreBtn = document.querySelector("[data-load-more-btn]")
const filterBtns = document.querySelectorAll("[data-filter-btn]")
const filterContainer = document.querySelector("[data-product-filters]")
const inputFields = document.querySelectorAll("[data-filter-input]")
var products_on_page = $("[data-products-on-page]")
var nextURL = products_on_page.data("next-url")
var currentURL = `https://${window.location.host}${window.location.pathname}`

if(loadMoreBtn) {
    loadMoreBtn.addEventListener("click", () => {
        loadMoreProducts()
    })
}

$("[data-filter-input]").on("change keyup paste", function(event){
    if( event.type === "keyup" && event.originalEvent.key == "Enter") {
        if(event.target == inputFields[1]) {
            submitPriceRange()
        }
            
    } else if(event.type != "keyup") {
        if(this.value === "") {
            this.parentNode.classList.remove("value")
        } else {
            this.parentNode.classList.add("value")
            this.value = Number(this.value).toFixed(2).toLocaleString('en')
        }
        if(Number(inputFields[0].value) > Number(inputFields[1].value) && inputFields[1].value != "") {
            inputFields[1].value = inputFields[0].value
        }
    }
})

filterBtns.forEach(button => {
    button.addEventListener("click", (event) => {
        var btnName = button.getAttribute("data-filter-btn")
        if(btnName === "show-filters") {
            if(event.target.innerHTML === "Show Search Filters") {
                event.target.innerHTML = "Hide Filters"
                event.target.setAttribute("aria-expanded", "true")
                filterContainer.classList.add("expanded")
            } else {
                event.target.innerHTML = "Show Search Filters"
                event.target.setAttribute("aria-expanded", "false")
                filterContainer.classList.remove("expanded")
            } 
        } else if(btnName === "reset") {
            inputFields.forEach(inputField => {
                inputField.parentNode.classList.remove("value")
                inputField.value = ""
            })
        } else if(btnName === "submit") {
            submitPriceRange()
        }
    })
})

function loadMoreProducts() {
    $.ajax(
        {
            url: nextURL,
            type: 'GET',
            dataType: 'html'
        }
    ).done(function(next_page) {
        var newProducts = $(next_page).find("[data-products-on-page]")
        var newURL = newProducts.data("next-url")
    
        nextURL = newURL
        if(nextURL === "" || nextURL === null || nextURL === undefined) {
            loadMoreBtn.disabled = true
        }
        console.log(products_on_page);
        products_on_page.append(newProducts.html())
    })
}

function submitPriceRange() {
    var min = inputFields[0].value
    var max = inputFields[1].value

    if(min == "") {
        min = 0
    }
    if(max == "") {
        max = 0
    }
    window.history.replaceState({}, {}, `${currentURL}?sort_by=price-ascending&filter.v.price.gte=${min}&filter.v.price.lte=${max}`)

    $('[data-collection-products-on-page]').load(location.href+' [data-collection-products-on-page]>*',"")
    // $('[data-testing]').load(location.href+' [data-testing]>*',"")
    // loadMoreBtn.addEventListener("click", () => {
    //     loadMoreProducts()
    // })
    // if(loadMoreBtn.disabled == true) {
    //     loadMoreBtn.disabled = false
    // }
    setTimeout(() => {
        products_on_page = $("[data-products-on-page]")
        nextURL = products_on_page.data("next-url")
    }, 1000)
}